module.exports = __webpack_public_path__ + "img/h_mid_1.7d7fca74.png";